import * as e from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/Presentation.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(n, { ref: r, ...t, weights: a }));
o.displayName = "PresentationIcon";
const m = o;
export {
  m as Presentation,
  o as PresentationIcon
};
